"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _getPropSelector = _interopRequireDefault(require("./getPropSelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const contentfulPropsTypes = {
  ..._Platform.default.select({
    web: {
      'data-contentful-field-id': _propTypes.default.string,
      'data-contentful-entry-id': _propTypes.default.string
    },
    default: {}
  })
};
var _default = exports.default = {
  /**
   * Set of contentful properties used for the content preview inspector.
   */
  types: contentfulPropsTypes,
  /**
   * Filters a props object, returning only contentful props.
   */
  select: (0, _getPropSelector.default)(contentfulPropsTypes)
};